import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { PlanningHistoryEntry } from 'src/app/models/entities/planning';
import { CommonService } from 'src/app/services/common.service';
import { QualityManagementService } from 'src/app/services/quality-management.service';

interface HistoryLogEntry {
  author: string;
  logTime: string;
  message: string;
}

@Component({
  selector: 'activities-planning-history',
  imports: [],
  templateUrl: './activities-planning-history.component.html',
  styleUrl: './activities-planning-history.component.scss'
})
export class ActivitiesPlanningHistoryComponent implements OnInit, OnChanges {

  @Input() planningId?: string | number;
  @Input() label: string = 'History';
  @Input() height: number = 220;

  historyLogEntries: HistoryLogEntry[] = [];
  isLoadingHistoryLogs: boolean = false;

  constructor(
    private qualityManagementService: QualityManagementService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.loadHistoryLogs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['planningId'] && !changes['planningId'].firstChange) {
      this.loadHistoryLogs();
    }
  }

  reload(): void {
    this.loadHistoryLogs();
  }

  private loadHistoryLogs(): void {
    if (!this.planningId) {
      this.historyLogEntries = [];
      return;
    }

    const params = new HttpParams().set('size', '9999');

    this.isLoadingHistoryLogs = true;
    this.qualityManagementService.listPlanningHistory(Number(this.planningId), { params }).subscribe({
      next: (response: any) => {
        const entries = this.readHistoryEntries(response);
        this.historyLogEntries = entries.map(entry => this.buildHistoryLogEntry(entry));
        this.isLoadingHistoryLogs = false;
      },
      error: (error: any) => {
        console.error('Error loading planning history:', error);
        this.historyLogEntries = [];
        this.isLoadingHistoryLogs = false;
      }
    });
  }

  private readHistoryEntries(response: any): PlanningHistoryEntry[] {
    const entries = this.qualityManagementService.readResponseKey(response, 'auditLogTextComponents');
    return Array.isArray(entries) ? entries : [];
  }

  private buildHistoryLogEntry(entry: PlanningHistoryEntry): HistoryLogEntry {
    return {
      author: (entry.author || 'Unknown user').toUpperCase(),
      logTime: this.formatHistoryLogTime(entry.logTime),
      message: (entry.message || '').trim() || '-'
    };
  }

  private formatHistoryLogTime(logTime?: string): string {
    if (!logTime) {
      return '';
    }

    const date = new Date(logTime);
    return isNaN(date.getTime()) ? '' : this.commonService.formatDate(date);
  }
}
